/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import selectContainerStyles from './Select2.styles';

// Renders the menu outside scrollable containers (e.g. the filter panel).
export const menuPortalProps = {
  menuPortalTarget: document.body,
  menuPosition: 'fixed',
  styles: { menuPortal: (base) => ({ ...base, zIndex: 1000 }) },
};

const Select2 = ({
  defaultValue,
  value,
  containerStyles,
  options,
  onChange,
  placeholder,
  portalMenu,
  ...rest
}) => (
  <Select
    classNamePrefix="select2"
    css={[selectContainerStyles, containerStyles]}
    value={value}
    defaultValue={defaultValue}
    options={options}
    onChange={onChange}
    isSearchable
    isClearable
    placeholder={placeholder}
    {...(portalMenu ? menuPortalProps : {})}
    {...rest}
  />
);

Select2.propTypes = {
  containerStyles: PropTypes.shape({}),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })]),
  defaultValue: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  portalMenu: PropTypes.bool,
};

Select2.defaultProps = {
  containerStyles: css``,
  value: { label: '', value: '' },
  defaultValue: { label: '', value: '' },
  placeholder: '',
  portalMenu: false,
};

export default Select2;
